import { tokens } from "../tokens";
export const ar = {
  [tokens.site.name]: "داينامكس ميديكا",
  [tokens.nav.home]: "اكتشف الجمال",
  [tokens.nav.contact]: "لنتواصل",
  [tokens.nav.about]: "قصتنا",
  [tokens.nav.brands]: "مجموعتنا المتميزة",
  [tokens.nav.vision]: "رؤيتنا",
  [tokens.common.discover_brands.title]: "اكتشف علاماتنا التجارية",
  [tokens.common.discover_brands.summary]:
    "اكتشف علاماتنا التجارية المتميزة في مجال الجمال والتجميل، والتي تم اختيارها بعناية لتحقيق نتائج استثنائية.",
  [tokens.common.buttons.readMore]: " اقرأ  المزيد",
  [tokens.commitment.title]: "التزامنا بالتميز",
  [tokens.about.page.button]: "رؤيتنا، مهمتنا وقيمنا",
  [tokens.about.page.card1]:
    "تأسست شركة داينامكس ميديكا المحدودة بهدف أن تصبح الموزع والشريك ومقدم الخدمات الرائد في مجال الجمال والتجميل. لدينا اهتمام مستهدف بسوق التجميل الطبي المتطور على المستويين المحلي والإقليمي. نسعى جاهدين لدمج الأفكار الجديدة وجهود التحديث مع الاستفادة في الوقت نفسه من الخبرة والمعرفة بالصناعة وولاء العملاء الذي بنيناه على مدى العقود القليلة الماضية.",
  [tokens.about.page.card2.title]: "مهمتنا",
  [tokens.about.page.card2.paragraph]:
    "نسعى جاهدين لتقديم منتجات وخدمات بأعلى جودة لعملائنا. من خلال مواردنا العميقة، نكرس أنفسنا لتطوير المجتمع ونموه. نعمل على بناء تحالفات استراتيجية مع الموردين، تهدف إلى تحقيق أهداف مشتركة وتلبية احتياجات العملاء. ومن خلال التحسين المستمر والوفاء بالتزاماتنا تجاه الآخرين، نتمكن من تحقيق طموحاتنا.",
  [tokens.about.page.card3.title]: "رؤيتنا",
  [tokens.about.page.card3.paragraph]:
    "رؤيتنا هي أن نكون شركة رائدة على مستوى العالم ولاعباً عالمياً مهماً من خلال تقديم حلول فريدة لتلبية الاحتياجات المتغيرة لجميع عملائنا",
  [tokens.about.page.card4.title]: "قوة تحويل الثقة والمظهر",
  [tokens.about.page.card4.paragraph]:
    "تقدم ديناميكس ميديكا مجموعة فريدة من المنتجات والخدمات التجميلية المتقدمة علمياً، مصممة حصرياً لصناعة عالمية من الأخصائيين ذوي المهارات العالية؛ مما يضمن حصول مجتمعنا على نتائج حقيقية، دائمة، واستثنائية، وبالتالي تحويل الثقة والمظهر، في كل مرة.",
  [tokens.commitment.paragraph]:
    "في ديناميكس ميديكا، نحن في رحلة ملهمة من النمو والتطور في عالم الجمال. شغفنا يقودنا لاستكشاف إمكانيات جديدة وجلب رؤى مبتكرة إلى مجالنا. نحن ملتزمون بتوسيع نطاق منتجاتنا وتعزيز خدماتنا بعناية، مع التركيز دائمًا على الجودة والابتكار.",
  [tokens.about.title]: "من نحن",
  [tokens.about.paragraph]:
    "نفخر بنهجنا الفريد، الذي يدمج خبرة المهنيين المتمرسين مع وجهات النظر الجديدة للمواهب الناشئة. هذا التآزر يمكننا من تطوير منتجات وخدمات متقدمة لا تواكب فقط اتجاهات الصناعة، بل غالباً ما تضع معايير جديدة.  في كل مشروع، نركز على الابتكار والجودة والكفاءة. نسعى جاهدين لتجاوز توقعات عملائنا، مقدمين تجارب وحلول تجميلية متميزة في عالم الجمال.",
  [tokens.cards.card1.title]: "خبرة عالمية، لمسة محلية",
  [tokens.cards.card1.paragraph]:
    "نجمع بين الخبرة الدولية والفهم العميق لمعايير الجمال المحلية، مما يضمن تناغم حلولنا مع السياقات الثقافية المتنوعة.",
  [tokens.cards.card2.title]: "النمو التعاوني",
  [tokens.cards.card2.paragraph]:
    "نؤمن بقوة التعاون، ونعزز الشراكات التي تدفع الابتكار والنمو في صناعة الجماليات.",
  [tokens.cards.card3.title]: "تمكين التعليم",
  [tokens.cards.card3.paragraph]:
    "نحن ملتزمون بتثقيف عملائنا وشركائنا حول أحدث التطورات في مجال الجماليات، مما يمكنهم من اتخاذ قرارات مستنيرة.",
  [tokens.cards.card4.title]: "تمكين العملاء",
  [tokens.cards.card4.paragraph]:
    "نهدف إلى تمكين عملائنا بالمعرفة والثقة، مساعدتهم على اتخاذ قرارات مستنيرة بشأن رحلتهم الجمالية.",

  [tokens.about.page.values.title]: "قيمنا",
  [tokens.about.page.values.value2.title]: "الشفافية",
  [tokens.about.page.values.value2.paragraph]:


    "نؤمن بالتواصل المفتوح والوضوح في جميع تعاملاتنا، مما يعزز بيئة من الثقة والتفاهم المتبادل.",


  [tokens.about.page.values.value3.title]: "الأخلاق",
  [tokens.about.page.values.value3.paragraph]:
    " نلتزم بمبادئ أخلاقية قوية، مع ضمان أن تكون ممارساتنا التجارية عادلة ومسؤولة ومحترمة لجميع أصحاب المصلحة.",


  [tokens.about.page.values.value5.title]: "المسؤولية",
  [tokens.about.page.values.value5.paragraph]:


    "نتحمل مسؤولية أفعالنا وقراراتنا، ونحاسب أنفسنا أمام عملائنا وشركائنا وبعضنا البعض.",
  [tokens.about.page.values.value1.title]: "الجودة",
  [tokens.about.page.values.value1.paragraph]:


    "نحن ملتزمون بتقديم منتجات وخدمات من الدرجة الأولى، مع ضمان أن كل جانب من جوانب عروضنا يلبي أو يتجاوز معايير الصناعة.",
  [tokens.about.page.values.value4.title]: "النزاهة",
  [tokens.about.page.values.value4.paragraph]:


    "نمارس أعمالنا بصدق وشفافية، مع الحفاظ على المعايير الأخلاقية وبناء الثقة مع شركائنا وعملائنا.",
  [tokens.about.page.values.value6.title]: "لتميز  في الأعمال",
  [tokens.about.page.values.value6.paragraph]:


    " نسعى جاهدين لتحقيق أعلى المعايير في جميع عملياتنا، مع التحسين المستمر لعملياتنا وخدماتنا لتقديم نتائج استثنائية لعملائنا.",
  [tokens.about.page.product.title]: "الالتزام بالتميز",
  [tokens.about.page.product.subtitle]: "خبرة عالمية، لمسة محلية",

  [tokens.about.page.product
    .paragraph]: `ينعكس سعينا نحو التميز في اختيارنا الدقيق للمنتجات، ومعرفة فريقنا من الخبراء، والتزامنا بالبقاء في طليعة التطورات الصناعية. نحن نؤمن بأن التميز الحقيقي لا يكمن فقط فيما نفعله، بل في كيفية قيامنا به - بشغف ونزاهة وتركيز لا هوادة فيه على تحقيق أفضل النتائج الممكنة لعملائنا.`,
  [tokens.about.page.paragraph]: "تمكين الجمال، إلهام الثقة",
  [tokens.contact.hero.paragraph]: "يسعدنا التواصل معك!",
  [tokens.contact.form.send]: "ارسل",
  [tokens.contact.form.title.mr]: "السيد",
  [tokens.contact.form.title.mrs]: "السيدة",
  [tokens.contact.form.firstName]: "الاسم الأول",
  [tokens.contact.form.lastName]: "اسم العائلة",
  [tokens.contact.form.organization]: "المنظمة",
  [tokens.contact.form.phone]: "رقم الهاتف",
  [tokens.contact.form.country]: "الدولة",
  [tokens.contact.form.interested_in]: "مهتم بـ",
  [tokens.contact.form.message]: "رسالة",
  [tokens.contact.form.terms]: "أوافق على الشروط والأحكام",
  [tokens.contact.form.terms_prefix]: "أوافق على",
  [tokens.contact.form.terms_link]: "الشروط والأحكام",
  [tokens.contact.form.update]:
    "نعم! يرجى إرسال التحديثات والمعلومات حول منتجاتكم.",
  [tokens.contact.info.title1]: "لنتواصل ونحول أحلامك الجمالية إلى حقيقة!",
  [tokens.contact.info.title2]: "اختر طريقتك المفضلة للتواصل معنا:",
  [tokens.contact.info.address]: "العنوان",
  [tokens.contact.info.address_info_city]: "شارع المدائن",
  [tokens.contact.info.address_info_street]: "رام الله، فلسطين",
  [tokens.contact.info.email]: "البريد الإلكتروني:",
  [tokens.contact.info.whatsapp]: "واتساب:",
  [tokens.contact.info.phone]: " الهاتف:",
  [tokens.contact.info.contact_info]: " معلومات الاتصال",
  [tokens.brands.ksurgery.skinbosoter]: "سكين بوستر",
  [tokens.brands.ksurgery.skinbooster1]: "أوبيرا REV سكين بوستر",
  [tokens.brands.ksurgery.skinboosterTitle1]:
    "أوبيرا REV سكين بوستر هي سلسلة من الفيلر المعزّز للحيوية والمحسن للأنسجة والتي وُلدت من خبرة Ksurgery، تعمل بفعالية على شيخوخة الجلد التي تتميز بالافتقار الخلوي، انخفاض التوتر، والخشونة.",
  [tokens.brands.ksurgery.benefits.title]: "الفوائد",
  [tokens.brands.ksurgery.benefits.description]:
    "تم تصميم سكين بوستر لتحسين مظهر وصحة البشرة التي تعاني من المشاكل التالية:",
  [tokens.brands.ksurgery.benefits.item1]: "فقدان مرونة البشرة.",
  [tokens.brands.ksurgery.benefits.item2]: "رقة الجلد.",
  [tokens.brands.ksurgery.benefits.item3]: "ترهل الجلد.",
  [tokens.brands.ksurgery.benefits.item4]: "التجاعيد الدقيقة إلى المتوسطة.",
  [tokens.brands.ksurgery.benefits.item5]: "الجفاف.",
  [tokens.brands.ksurgery.benefits.item6]: "الندبات الليفية.",
  [tokens.brands.ksurgery.title]: "كيه سيرجري",
  [tokens.brands.ksurgery.subtitle]: "اكتشف كيه سيرجري",
  [tokens.brands.ksurgery.description]:
    "تمزج علاجات حمض الهيالورونيك الإيطالية الصنع لدينا بين التكنولوجيا المتطورة وتعزيز الجمال الطبيعي. تقدم Ksurgery MED، من Vidapharma، منتجات آمنة وفعالة ومثبتة علميًا، مصممة لتلبية المعايير العالية للمتخصصين الطبيين في مجال الرعاية الجمالية.",
  [tokens.brands.ksurgery.description2]:
    " تمزج علاجات حمض الهيالورونيك الإيطالية الصنع لدينا بين التكنولوجيا المتطورة وتعزيز الجمال الطبيعي. تقدم Ksurgery MED، من Vidapharma، منتجات آمنة وفعالة ومثبتة علميًا، مصممة لتلبية المعايير العالية للمتخصصين الطبيين في مجال الرعاية الجمالية.",
  [tokens.brands.ksurgery.description3]:
    "سكين بوستر يمكنه تصحيح التجاعيد من الدقيقة إلى المتوسطة الوضوح، وهو مثالي لعلاج تلف البشرة الناتج عن التعرض للشمس وعوامل الزمن. يضمن تجديد سريع للأدمة، وتحسين فوري في التماسك، وترطيب أفضل وزيادة في الإشراق.",
  [tokens.brands.ksurgery.whatIs]: "ما هو جوفيلوك؟",
  [tokens.brands.ksurgery.whatIsDescription]:
    "جوفلوك هو حقن يعتمد على مادة PDLLA تحفز إنتاج الكولاجين، مما يوفر تجديدًا طبيعيًا وطويل الأمد للبشرة. تم تصميمه لتحسين جودة البشرة من خلال معالجة علامات الشيخوخة مع الحد الأدنى من التداخل والتوقف.",
  [tokens.brands.ksurgery.keyBenefits]: "الفوائد الرئيسية",
  [tokens.brands.ksurgery.keyBenefit1]: "يحسن نسيج البشرة ومرونتها وثباتها",
  [tokens.brands.ksurgery.keyBenefit2]: "يُنعّم الخطوط الدقيقة والتجاعيد.",
  [tokens.brands.ksurgery.keyBenefit3]: "نتائج طويلة الأمد مع تحسن تدريجي.",
  [tokens.brands.ksurgery.howIs]: "كيف يعمل؟",
  [tokens.brands.ksurgery.howIsDescription]:
    "يستخدم جوفلوك مادة PDLLA القابلة للتحلل الحيوي التي تحفز بشكل تدريجي تكوين الكولاجين، مما يساعد على استعادة جودة البشرة الشابة مع مرور الوقت.",
  [tokens.brands.ksurgery.results]: "المناطق المستهدفة",
  [tokens.brands.ksurgery.result1]: "الوجه",
  [tokens.brands.ksurgery.result2]: "الرقبة",
  [tokens.brands.ksurgery.result3]: "اليدين",
  [tokens.brands.ksurgery.application]: "التطبيق والنتائج",
  [tokens.brands.ksurgery.applicationDescription]:
    "يقدم جوفلوك نتائج تدريجية وطبيعية تدوم مع مرور الوقت، مما يعزز بشرة أكثر نعومة وثباتًا مع جلسات علاجية قليلة.",
  [tokens.brands.ksurgery.products[0].face[0].title]: "أوبرا I",
  [tokens.brands.ksurgery.products[0].face[0].subtitle]: "الخطوط الدقيقة",
  [tokens.brands.ksurgery.products[0].face[0].buttonTitle]: "أوبرا I",
  [tokens.brands.ksurgery.products[0].face[0].description]:
    "فيلر ناعم قادر على تصحيح التجاعيد من الدقيقة إلى المتوسطة.",
  [tokens.brands.ksurgery.products[0].face[0].items[0]]:
    "العلاج: خطوط الباركود؛ ندوب حب الشباب؛ الخطوط حول الفم، الخدين، خطوط المدخنين، أقدام الغراب",
  [tokens.brands.ksurgery.products[0].face[0].items[1]]:
    "تأثير تعزيز الحجم: ناعم",
  [tokens.brands.ksurgery.products[0].face[0].items[2]]: "العبوة: 1x1مل",
  [tokens.brands.ksurgery.products[0].face[0].items[3]]:
    "تركيز الهيالورونيك: 1x1مل",

  [tokens.brands.ksurgery.products[0].face[1].title]: "أوبرا II",
  [tokens.brands.ksurgery.products[0].face[1].subtitle]:
    "الخطوط المتوسطة السطحية",
  [tokens.brands.ksurgery.products[0].face[1].buttonTitle]: "أوبرا II",
  [tokens.brands.ksurgery.products[0].face[1].description]:
    "فيلر متوسط بقوام ناعم قادر على تصحيح الخطوط المتوسطة السطحية للجسم، وإعادة تحديد حجم الأنف والصدغين بالإضافة إلى تعزيز حجم الشفاه.",
  [tokens.brands.ksurgery.products[0].face[1].items[0]]:
    "العلاج: الأنف؛ تحت العين؛ الشفاه؛ الصدغين؛ التجاعيد المتوسطة العميقة؛ خطوط العبوس، الطيات الأنفية الشفوية، خطوط الضحك، خطوط الأكورديون",
  [tokens.brands.ksurgery.products[0].face[1].items[1]]:
    "تأثير تعزيز الحجم: ناعم",
  [tokens.brands.ksurgery.products[0].face[1].items[2]]: "العبوة: 1x1مل",
  [tokens.brands.ksurgery.products[0].face[1].items[3]]:
    "تركيز الهيالورونيك: 1x1مل",

  [tokens.brands.ksurgery.products[0].face[2].title]: "أوبرا III",
  [tokens.brands.ksurgery.products[0].face[2].subtitle]:
    "التجاعيد الأعمق وخطوط الابتسامة",
  [tokens.brands.ksurgery.products[0].face[2].buttonTitle]: "أوبرا III",
  [tokens.brands.ksurgery.products[0].face[2].description]:
    "فيلر قادر على تصحيح الخطوط الأعمق مثل الطيات الأنفية الشفوية، خطوط الماريونيت، حدود الفك، أحجام الخدود الصغيرة وتحقيق شفاه ممتلئة.",
  [tokens.brands.ksurgery.products[0].face[2].items[0]]:
    "العلاج: الطيات الأنفية الشفوية؛ خطوط الماريونيت؛ حدود الفك؛ التجاعيد العميقة؛ الشفاه؛ الطيات العميقة؛ أقدام الغراب؛ تحت العين؛ خطوط الأنف؛ الخطوط حول الفم؛ خطوط المدخنين",
  [tokens.brands.ksurgery.products[0].face[2].items[1]]:
    "تأثير تعزيز الحجم: قوي",
  [tokens.brands.ksurgery.products[0].face[2].items[2]]: "العبوة: 1x1مل",
  [tokens.brands.ksurgery.products[0].face[2].items[3]]:
    "تركيز الهيالورونيك: 1x1مل",

  [tokens.brands.ksurgery.products[0].face[3].title]: "أوبرا IV",
  [tokens.brands.ksurgery.products[0].face[3].subtitle]:
    "الخطوط العميقة وعلامات التقدم في العمر",
  [tokens.brands.ksurgery.products[0].face[3].buttonTitle]: "أوبرا IV",
  [tokens.brands.ksurgery.products[0].face[3].description]:
    "فيلر حجمي مصمم لمكافحة علامات التقدم في العمر الواضحة من خلال إنشاء تأثير رفع صغير لطيف. يعالج الطيات العميقة، ويعيد تشكيل هياكل حدود الفك ويعمل بشكل كبير على الخدين والأنف.",
  [tokens.brands.ksurgery.products[0].face[3].items[0]]:
    "العلاج: الطيات الأنفية الشفوية؛ خطوط الماريونيت؛ حدود الفك؛ التجاعيد العميقة؛ الشفاه؛ الطيات العميقة؛ الطية الذقنية؛ تجاعيد الذقن؛ الخدود؛ ترهل الجلد",
  [tokens.brands.ksurgery.products[0].face[3].items[1]]:
    "تأثير تعزيز الحجم: قوي",
  [tokens.brands.ksurgery.products[0].face[3].items[2]]: "العبوة: 1x1مل",
  [tokens.brands.ksurgery.products[0].face[3].items[3]]:
    "تركيز الهيالورونيك: 1x1مل",
  [tokens.brands.ksurgery.products[0].body[0].title]: "أوبرا V حشو الجسم",
  [tokens.brands.ksurgery.products[0].body[0].subtitle]:
    "إعادة تشكيل الساقين والأرداف بدون جراحة",
  [tokens.brands.ksurgery.products[0].body[0].buttonTitle]: "أوبرا V",
  [tokens.brands.ksurgery.products[0].body[0].description]:
    "أوبرا V هو الحشو المبتكر من الجيل الأخير المصمم لعلاج فراغات الجسم وكذلك تكبير الأرداف، ملء الساقين أو إعادة تشكيل الركبتين. يضمن الترطيب الأمثل، وتجديد الأنسجة، ومنحها نغمة جديدة، حيث تفشل الحمية الغذائية المتوازنة والنشاط البدني المعتدل في تحقيق النتائج.",
  [tokens.brands.ksurgery.products[0].body[0].description2]:
    "حشو الجسم لدينا يضمن الامتصاص الكامل وغياب تام للحبيبات بعد العلاج. بعد العلاج، يمكنك استئناف أنشطتك اليومية على الفور.",
  [tokens.brands.ksurgery.products[1].face[0].title]:
    "أوبرا ريف سكين بوستر إيفولوشن L",
  [tokens.brands.ksurgery.products[1].face[0].subtitle]: "حشو حيوي مجدد للبشرة",
  [tokens.brands.ksurgery.products[1].face[0].buttonTitle]: "إيفولوشن L",
  [tokens.brands.ksurgery.products[1].face[0].description]:
    "مُعزّز للبشرة يحتوي على حمض الهيالورونيك بتركيبة مجددة للبنية، قليل الترابط، مصمم لتقليل الخطوط الدقيقة، وتحسين نسيج البشرة، ومنح مظهر أكثر شبابًا.",
  [tokens.brands.ksurgery.products[1].face[0].items[0]]:
    "مناطق التطبيق: الجبهة، المنطقة المحيطة بالعين، المنطقة الأنفية الشفوية، المنطقة المحيطة بالفم، الخدين، عظام الوجنتين، اليدين، الرقبة، ومنطقة الصدر",
  [tokens.brands.ksurgery.products[1].face[0].items[1]]:
    "طريقة التطبيق: تقنية إيڤا",
  [tokens.brands.ksurgery.products[1].face[0].items[2]]:
    "أوزان جزيئية لحمض الهيالورونيك: ٥٠٠ كيلو دالتون | ١٠٠٠ كيلو دالتون | ٢٠٠٠ كيلو دالتون",
  [tokens.brands.ksurgery.products[1].face[0].items[3]]:
    "تركيز حمض الهيالورونيك المرتبط: ٢٠ ملغ/مل",

  [tokens.brands.ksurgery.products[1].face[1].title]:
    "أوبرا ريف سكين بوستر إيفولوشن S",
  [tokens.brands.ksurgery.products[1].face[1].subtitle]: "حشو مجدد للبشرة",
  [tokens.brands.ksurgery.products[1].face[1].buttonTitle]: "إيفولوشن S",
  [tokens.brands.ksurgery.products[1].face[1].description]:
    "سكين بوستر للوجه يحتوي على حمض الهيالورونيك قليل الترابط، بتركيبة مجددة للبنية. مثالي لتصحيح العيوب الطفيفة في الوجه، وتوفير ترطيب مكثف للبشرة، ومنح النعومة للمناطق ذات المرونة المنخفضة.",
  [tokens.brands.ksurgery.products[1].face[1].items[0]]:
    "مناطق التطبيق: الجبهة، المنطقة المحيطة بالعين، المنطقة الأنفية الشفوية، المنطقة المحيطة بالفم، الخدين، عظام الوجنتين، اليدين، الرقبة ومنطقة الصدر.",
  [tokens.brands.ksurgery.products[1].face[1].items[1]]:
    "طريقة التطبيق: تقنية إيڤا",
  [tokens.brands.ksurgery.products[1].face[1].items[2]]:
    "الأوزان الجزيئية لحمض الهيالورونيك: ١٠٠٠ كيلو دالتون | ١٥٠٠ كيلو دالتون",
  [tokens.brands.ksurgery.products[1].face[1].items[3]]:
    "تركيز حمض الهيالورونيك المرتبط: ٢٠ ملغ/مل",

  [tokens.brands.ksurgery.products[1].body[0].title]:
    "أوبرا ريف سكين بوستر ديفا",
  [tokens.brands.ksurgery.products[1].body[0].subtitle]: "حشو مجدد للبشرة",
  [tokens.brands.ksurgery.products[1].body[0].buttonTitle]: "أوبرا في",
  [tokens.brands.ksurgery.products[1].body[0].description]:
    "سكين بوستر ثوري للجسم تم تطويره خصيصًا لإعادة تشكيل الأنسجة المترهلة للبشرة، وزيادة ترطيب الجلد، وتحفيز تجديد الأنسجة.",
  [tokens.brands.ksurgery.products[1].body[0].items[0]]:
    "مناطق التطبيق: البطن، الأرداف، الفخذين الداخليين، الركبتين، وتحت الذراعين.",
  [tokens.brands.ksurgery.products[1].body[0].items[1]]:
    "الأوزان الجزيئية لحمض الهيالورونيك: ١٠٠٠ كيلو دالتون | ١٥٠٠ كيلو دالتون",
  [tokens.brands.ksurgery.products[1].body[0].items[2]]:
    "تركيز حمض الهيالورونيك المرتبط: ٢٠ ملغ/مل",
  [tokens.brands.ksurgery.opera]: "أوبرا",
  [tokens.brands.ksurgery.operaDescription]:
    "أنشأت Ksurgery أوبرا، مجموعة من الفيلر المعتمد على حمض الهيالورونيك، التي تحتوي على تركيزات مختلفة لتلبية جميع الاحتياجات وضمان تأثير رفع فوري وآمن وغير جراحي.",
  [tokens.brands.ksurgery.operaDescription1]:
    "خط من الفيلرات المعتمدة، الآمنة، طويلة الأمد وقابلة لإعادة الامتصاص بالكامل.",
  [tokens.brands.ksurgery.operaDescription2]:
    "%100 MADE-IN-ITALY، مرادف للضمان والتفوق.",

  [tokens.brands.renee.description2]:
    "تم تصميم جل حمض الهيالورونيك القابل للحقن لدينا بعناية لترطيب البشرة وتجديدها، مما يمنح مظهرًا منتعشًا وشابًا. مع التركيبات المتقدمة، تقدم رينيه حلولًا فعالة لمختلف الاحتياجات الجمالية.",
  [tokens.brands.juvelook.description2]:
    "حشوة PLA الفريدة لدينا تعزز مظهرك بدقة. يتم حقن جزيئات PDLLA الصغيرة في الأدمة، مما يزيد حجم البشرة بشكل متساوٍ عن طريق تعزيز إنتاج الكولاجين.",
  [tokens.brands.lenisna.description2]:
    " جزيئاتنا الكروية المبتكرة تحفز إنتاج الكولاجين، مما يوفر حجمًا طبيعيًا لتحديد معالم الوجه والجسم. مثالية لتقليل التجاعيد وعلاج الندبات.",
  [tokens.brands.lenisna.whatIs]: "ما هو لينيسنا؟",
  [tokens.brands.lenisna.whatIsDescription]:
    "لينيسنا هو حقن متقدم يحتوي على مادة PDLLA لتحفيز إنتاج الكولاجين، بهدف تحسين جمالية البشرة وتقليل علامات الشيخوخة بشكل فعال.",
  [tokens.brands.lenisna.keyBenefits]: "الفوائد الرئيسية",
  [tokens.brands.lenisna.keyBenefit1]: "يستعيد حجم البشرة ونعومتها.",
  [tokens.brands.lenisna.keyBenefit2]: "يحسن نسيج البشرة ومرونتها بشكل عام.",
  [tokens.brands.lenisna.keyBenefit3]:
    "يوفر نتائج طبيعية وملحوظة دون توقف كبير.",
  [tokens.brands.lenisna.howIs]: "كيف يعمل؟",
  [tokens.brands.lenisna.howIsDescription]:
    "مادة PDLLA في لينيسنا تعزز تكوين الكولاجين، مما يساهم في تجديد البشرة وتقليل الخطوط الدقيقة والتجاعيد.",
  [tokens.brands.lenisna.results]: "المناطق المستهدفة",
  [tokens.brands.lenisna.result1]: "الوجه",
  [tokens.brands.lenisna.result2]: "الرقبة",
  [tokens.brands.lenisna.result3]: "اليدين",
  [tokens.brands.lenisna.application]: "التطبيق والنتائج",
  [tokens.brands.lenisna.applicationDescription]:
    "تؤدي تأثيرات لينيسنا التدريجية والطويلة الأمد إلى بشرة أكثر نعومة وثباتًا مع خطوط أقل وتحسن في النسيج، مما يساعد المرضى في الحصول على بشرة أكثر شبابًا.",
  [tokens.brands.lenisna.pageTitle]: " لينيسنا   ",
  [tokens.brands.lenisna.pageDescription]:
    " يوفر لينيسنا تركيبة عالية النقاء من PDLLA مع حمض الهيالورونيك لرفع ملامح الوجه واستعادة الحجم المفقود ومعالجة التجاعيد العميقة بفعالية ",
  [tokens.brands.renee.title]: "رينيه",
  [tokens.brands.renee.subtitle]: "اكتشف رينيه",
  [tokens.brands.renee.description]:
    "تم تصميم جل حمض الهيالورونيك القابل للحقن لدينا بعناية لترطيب البشرة وتجديدها، مما يمنح مظهرًا منتعشًا وشابًا. مع التركيبات المتقدمة، تقدم رينيه حلولًا فعالة لمختلف الاحتياجات الجمالية.",

  [tokens.brands.renee.whatIs]: "ما هو رينيه",
  [tokens.brands.renee.whatIsDescription]:
    "ريني هو خط فاخر من الجل القائم على حمض الهيالورونيك المصمم لتعزيز واستعادة مظهر البشرة الشابة. تشمل مجموعة المنتجات المحفزات الجلدية الخاصة وحشوات الجلد، حيث يستهدف كل منها مناطق وجه محددة لتحسين الحجم، والنسيج، والترطيب.",
  [tokens.brands.renee.keyBenefits]: "الفوائد الرئيسية",
  [tokens.brands.renee.keyBenefit1]: "نتائج طبيعية المظهر وناعمة.",
  [tokens.brands.renee.keyBenefit2]: "تأثيرات فورية وطويلة الأمد.",
  [tokens.brands.renee.keyBenefit3]: "علاجات قابلة للتخصيص لتجديد مخصص.",
  [tokens.brands.renee.howIs]: "كيف يعمل؟",
  [tokens.brands.renee.howIsDescription]:
    "يستخدم ريني مادة PDLLA، وهي مادة قابلة للتحلل تعزز تدريجيًا تخليق الكولاجين، مما يساعد على استعادة جودة البشرة الشابة مع مرور الوقت.",
  [tokens.brands.renee.results]: "المناطق المستهدفة",
  [tokens.brands.renee.result1]: "الوجه",
  [tokens.brands.renee.result2]: "الرقبة",
  [tokens.brands.renee.result3]: "اليدين",
  [tokens.brands.renee.application]: "التطبيق والنتائج",
  [tokens.brands.renee.applicationDescription]:
    "يوفر ريني نتائج تدريجية وطبيعية المظهر تدوم مع مرور الوقت، مما يعزز البشرة الأكثر نعومة وثباتًا مع جلسات علاجية قليلة.",

  [tokens.brands.renee.products[0].skin[0].title]: "معزز البشرة من رينيه",
  [tokens.brands.renee.products[0].skin[0].subtitle]: "يُعيد إشراقة بشرتك",
  [tokens.brands.renee.products[0].skin[0].preQuestion]: "رينيه برايم",
  [tokens.brands.renee.products[0].skin[0].question]:
    "ما هو معزز البشرة من رينيه؟",
  [tokens.brands.renee.products[0].skin[0].buttonTitle]: "معزز البشرة من رينيه",
  [tokens.brands.renee.products[0].skin[0].description]:
    "حقن مرطب مصمم لتحسين ملمس البشرة ومرونتها، مع تنشيط البشرة للحصول على مظهر مشرق.",
  [tokens.brands.renee.products[0].skin[0].items[0]]: "ترطيب عميق للبشرة",
  [tokens.brands.renee.products[0].skin[0].items[1]]: "تحسين الملمس والمرونة",
  [tokens.brands.renee.products[0].skin[0].items[2]]: "نتائج تدوم طويلاً",

  [tokens.brands.renee.products[0].skin[1].title]: "رينيه فوليوم",
  [tokens.brands.renee.products[0].skin[1].subtitle]:
    "لاستعادة حجم الوجه وتحديد معالمه",
  [tokens.brands.renee.products[0].skin[1].question]: "ما هو رينيه فوليوم؟",
  [tokens.brands.renee.products[0].skin[1].buttonTitle]: "رينيه فوليوم",
  [tokens.brands.renee.products[0].skin[1].description]:
    "يستعيد رينيه فوليوم الحجم في المناطق التي فقدت الحجم، مما يعزز التناسق والشكل الشبابي للوجه.",
  [tokens.brands.renee.products[0].skin[1].items[0]]: "يستعيد حجم الوجه",
  [tokens.brands.renee.products[0].skin[1].items[1]]: "ينعم معالم الوجه",
  [tokens.brands.renee.products[0].skin[1].items[2]]: "يعزز الشباب والتناسق",

  [tokens.brands.renee.products[0].skin[2].title]: "رينيه تاتش",
  [tokens.brands.renee.products[0].skin[2].subtitle]:
    "لتنعيم الخطوط الدقيقة والمتوسطة والتجاعيد",
  [tokens.brands.renee.products[0].skin[2].question]: "ما هو رينيه تاتش؟",
  [tokens.brands.renee.products[0].skin[2].buttonTitle]: "رينيه تاتش",
  [tokens.brands.renee.products[0].skin[2].description]:
    "يعالج رينيه تاتش الخطوط الدقيقة، ويوفر ترطيبًا عميقًا لتحسين مرونة البشرة وملمسها للحصول على مظهر أكثر شبابًا.",
  [tokens.brands.renee.products[0].skin[2].items[0]]:
    "يحسن ملمس البشرة ومرونتها",
  [tokens.brands.renee.products[0].skin[2].items[1]]: "ينعم الخطوط الدقيقة",
  [tokens.brands.renee.products[0].skin[2].items[2]]:
    "ترطيب عميق لبشرة أكثر صحة",

  [tokens.brands.renee.products[0].skin[3].title]: "رينيه سمايل",
  [tokens.brands.renee.products[0].skin[3].subtitle]:
    "لتعزيز حجم الشفاه وتحديد معالمها",
  [tokens.brands.renee.products[0].skin[3].question]: "ما هو رينيه سمايل؟",
  [tokens.brands.renee.products[0].skin[3].buttonTitle]: "رينيه سمايل",
  [tokens.brands.renee.products[0].skin[3].description]:
    "علاج مستهدف يركز على منطقة الابتسامة، ينعم الخطوط الدقيقة ويعيد الحجم للحصول على ابتسامة أكثر شبابًا وسلاسة.",
  [tokens.brands.renee.products[0].skin[3].items[0]]: "يقلل التجاعيد حول الفم",
  [tokens.brands.renee.products[0].skin[3].items[1]]: "يعيد الحجم المفقود",
  [tokens.brands.renee.products[0].skin[3].items[2]]: "يعزز مظهر الابتسامة",

  [tokens.brands.renee.products[0].skin[4].title]: "رينيه ليفت",
  [tokens.brands.renee.products[0].skin[4].subtitle]:
    "لملء التجاعيد العميقة والطيات",
  [tokens.brands.renee.products[0].skin[4].question]: "ما هو رينيه ليفت؟",
  [tokens.brands.renee.products[0].skin[4].buttonTitle]: "رينيه ليفت",
  [tokens.brands.renee.products[0].skin[4].description]:
    "حل رفع يستعيد الحجم ويوفر مظهرًا أكثر تماسكًا وتحديدًا، خاصة للبشرة المترهلة.",
  [tokens.brands.renee.products[0].skin[4].items[0]]: "تأثيرات رفع طويلة الأمد",
  [tokens.brands.renee.products[0].skin[4].items[1]]:
    "يستعيد الحجم في المناطق الرئيسية",
  [tokens.brands.renee.products[0].skin[4].items[2]]:
    "يرفع ويحدد البشرة المترهلة",

  [tokens.brands.lenisna.title]: "لينيسنا",
  [tokens.brands.lenisna.subtitle]: "اكتشف لينيسنا",
  [tokens.brands.lenisna.description]:
    "جزيئاتنا الكروية المبتكرة تحفز إنتاج الكولاجين، مما يوفر حجمًا طبيعيًا لتحديد معالم الوجه والجسم. مثالية لتقليل التجاعيد وعلاج الندبات.",
  [tokens.brands.lenisna.products[0].title]:
    "عزّز جمالك الطبيعي وزِد ثقتك بنفسك",
  [tokens.brands.lenisna.products[0].aging[0].title1]: "التطبيق والنتائج",
  [tokens.brands.lenisna.products[0].aging[0].title2]: "المكون النشط",
  [tokens.brands.lenisna.products[0].aging[0].title3]: "مدة التأثير",
  [tokens.brands.lenisna.products[0].aging[0].title4]: "زيادة الحجم",
  [tokens.brands.lenisna.products[0].aging[0].description1]:
    "تؤدي التأثيرات التدريجية طويلة الأمد لمنتج لينسنا إلى بشرة أكثر نعومة وثباتًا مع خطوط أقل وتحسين في الملمس، مما يساعد المرضى على تحقيق بشرة أكثر شبابًا.",
  [tokens.brands.lenisna.products[0].aging[0].description2]:
    "يحتوي المنتج على 42.4 ملغ من حمض بولي-دي إل-لاكيتيك (PDLLA) و 7.5 ملغ من حمض الهيالورونيك مع مدة تأثير تتراوح بين 12 و 18 شهرًا.",
  [tokens.brands.lenisna.products[0].aging[0].description3]: "18 - 24 شهرًا",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[0]]: "نحت الوجه",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[1]]: "نحت الجسم",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[2]]: "تكبير الوجه",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[3]]: "تكبير الجسم",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[4]]:
    "علاج التجاعيد العميقة",
  [tokens.brands.lenisna.products[0].aging[0].volumeItems[5]]:
    "علاج الندبات العميقة",
  [tokens.brands.lenisna.products[0].aging[0].items[0]]:
    "يعيد حجم البشرة ونعومتها.",
  [tokens.brands.lenisna.products[0].aging[0].items[1]]:
    "يحسن الملمس العام للبشرة ومرونتها.",
  [tokens.brands.lenisna.products[0].aging[0].items[2]]:
    "يوفر نتائج طبيعية ودقيقة بدون وقت تعطل كبير.",
  [tokens.brands.lenisna.face.title]: "منطقة الحقن",
  [tokens.brands.lenisna.face.point1]: "الجبهة",
  [tokens.brands.lenisna.face.point2]: "الصدغين",
  [tokens.brands.lenisna.face.point3]: "الطيات الأنفية الشفوية",
  [tokens.brands.lenisna.face.point4]: "خطوط الماريونيت",
  [tokens.brands.lenisna.face.point5]: "خطوط الفك",
  [tokens.brands.lenisna.face.point6]: "ظهر اليدين",
  [tokens.brands.lenisna.face.point7]: "منطقة الخدود",
  [tokens.brands.lenisna.face.point8]: "ندبة عميقة",
  [tokens.brands.lenisna.body.point1]: "الديكولتيه",
  [tokens.brands.lenisna.body.point2]:
    "ترهل الجلد (الذراعين، الفخذين، الركبتين)",
  [tokens.brands.lenisna.body.point3]: "الأرداف",
  [tokens.brands.lenisna.body.point4]: "تقليل السيلوليت",
  [tokens.brands.lenisna.body.point5]: "علامات التمدد",
  [tokens.brands.juvelook.pageTitle]: "جوفيلوك",

  [tokens.brands.juvelook.pageDescription]:
    "يجمع جوفيلوك بين PDLLA وحمض الهيالورونيك لتحفيز الكولاجين بلطف، مما يحسّن نسيج البشرة ويزيد من إشراقها بنتائج طبيعية.",

  [tokens.brands.juvelook.face.point1]: "تجديد البشرة (الوجه بالكامل)",
  [tokens.brands.juvelook.face.point2]: "تحت العين (الشق الدمعي)",
  [tokens.brands.juvelook.face.point3]: "التجاعيد الدقيقة",
  [tokens.brands.juvelook.face.point7]: "تجاعيد الرقبة",
  [tokens.brands.juvelook.face.point6]: "ندوب حب الشباب الضامرة",
  [tokens.brands.juvelook.face.point5]: "شد الجلد أسفل الجفن",
  [tokens.brands.juvelook.face.point4]: "الهالات السوداء",
  [tokens.brands.juvelook.products[0].title]: "اكتشف جمال الطبيعة من جديد",
  [tokens.brands.juvelook.products[0].aging[0].title1]: "التطبيق والنتائج",
  [tokens.brands.juvelook.products[0].aging[0].title2]: "المكونات النشطة",
  [tokens.brands.juvelook.products[0].aging[0].title3]: "مدة التأثير",
  [tokens.brands.juvelook.products[0].aging[0].title4]: "تجديد البشرة",
  [tokens.brands.juvelook.products[0].aging[0].description1]:
    "يمنح Juvelook نتائج طبيعية ومتدرجة تدوم لفترات طويلة، مما يعزز نعومة البشرة وثباتها مع تقليل جلسات العلاج.",
  [tokens.brands.juvelook.products[0].aging[0].description2]:
    "يحتوي المنتج على 42.4 ملغ من حمض بولي-دي إل-لاكيتيك (PDLLA) و 7.5 ملغ من حمض الهيالورونيك مع مدة تأثير تتراوح بين 12 و 18 شهرًا.",
  [tokens.brands.juvelook.products[0].aging[0].description3]: "12 - 18 شهرًا",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[0]]: "تفتيح البشرة",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[1]]:
    "شد مسام البشرة",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[2]]:
    "تحسين ملمس البشرة",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[3]]:
    "تحسين مرونة البشرة",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[4]]:
    "علاج الندوب الضامرة",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[5]]:
    "علاج علامات التمدد",
  [tokens.brands.juvelook.products[0].aging[0].volumeItems[6]]:
    "علاج التجاعيد الدقيقة",
  [tokens.brands.juvelook.products[0].aging[0].items[0]]:
    "يعزز ملمس البشرة ومرونتها وثباتها.",
  [tokens.brands.juvelook.products[0].aging[0].items[1]]:
    "يقلل من الخطوط الدقيقة والتجاعيد.",
  [tokens.brands.juvelook.products[0].aging[0].items[2]]:
    "نتائج طويلة الأمد مع تحسين تدريجي.",

  [tokens.brands.juvelook.title]: "جوفيلوك",
  [tokens.brands.juvelook.subtitle]: "اكتشف جوفيلوك",
  [tokens.brands.juvelook.description]:
    "حشوة PLA الفريدة لدينا تعزز مظهرك بدقة. يتم حقن جزيئات PDLLA الصغيرة في الأدمة، مما يزيد حجم البشرة بشكل متساوٍ عن طريق تعزيز إنتاج الكولاجين.",
  [tokens.brands.juvelook.whatIs]: "ما هو جوفيلوك؟",
  [tokens.brands.juvelook.whatIsDescription]:
    "جوفلوك هو حقن يعتمد على مادة PDLLA تحفز إنتاج الكولاجين، مما يوفر تجديدًا طبيعيًا وطويل الأمد للبشرة. تم تصميمه لتحسين جودة البشرة من خلال معالجة علامات الشيخوخة مع الحد الأدنى من التداخل والتوقف.",
  [tokens.brands.juvelook.keyBenefits]: "الفوائد الرئيسية",
  [tokens.brands.juvelook.keyBenefit1]: "يحسن نسيج البشرة ومرونتها وثباتها",
  [tokens.brands.juvelook.keyBenefit2]: "يُنعّم الخطوط الدقيقة والتجاعيد.",
  [tokens.brands.juvelook.keyBenefit3]: "نتائج طويلة الأمد مع تحسن تدريجي.",
  [tokens.brands.juvelook.howIs]: "كيف يعمل؟",
  [tokens.brands.juvelook.howIsDescription]:
    "يستخدم جوفلوك مادة PDLLA القابلة للتحلل الحيوي التي تحفز بشكل تدريجي تكوين الكولاجين، مما يساعد على استعادة جودة البشرة الشابة مع مرور الوقت.",
  [tokens.brands.juvelook.results]: "المناطق المستهدفة",
  [tokens.brands.juvelook.result1]: "الوجه",
  [tokens.brands.juvelook.result2]: "الرقبة",
  [tokens.brands.juvelook.result3]: "اليدين",
  [tokens.brands.juvelook.application]: "التطبيق والنتائج",
  [tokens.brands.juvelook.applicationDescription]:
    "يقدم جوفلوك نتائج تدريجية وطبيعية تدوم مع مرور الوقت، مما يعزز بشرة أكثر نعومة وثباتًا مع جلسات علاجية قليلة.",
  [tokens.common.discover_brand]: "اكتشف العلامة التجاريه",
  [tokens.brands.our_collection.title]: "المنتجات المختارة",
  [tokens.brands.our_collection.title1]: "مجموعة العلامات التجارية",
  [tokens.brands.our_collection.paragraph]:
    "في ديناميكس ميديكا، قمنا بتطوير مجموعة متميزة من التقنيات الجمالية المبتكرة. نحن نلبي الاحتياجات الطبية غير المستوفاة من خلال توفير علاجات فعالة وطويلة الأمد وغير جراحية. هدفنا هو تقديم نتائج طبيعية المظهر تعزز جمال عملائنا بطريقة آمنة ومدروسة.",
  [tokens.brands.our_collection.paragraph2]: "الحقن التجميلية",
  [tokens.brands.our_collection.paragraph3]:
    "استكشف مجموعتنا المميزة من العلامات التجارية",
  [tokens.brands.our_collection.face]: "الوجه",
  [tokens.brands.our_collection.body]: "الجسم",

  // الشروط والأحكام
  [tokens.terms.page.title]: "الشروط والأحكام",
  [tokens.terms.page.lastUpdated]: "آخر تحديث: ديسمبر 2024",
  [tokens.terms.page.introduction.title]: "مقدمة",
  [tokens.terms.page.introduction.content]:
    "مرحباً بكم في داينامكس ميديكا. تحكم هذه الشروط والأحكام استخدامكم لموقعنا الإلكتروني وخدماتنا. من خلال الوصول إلى خدماتنا أو استخدامها، فإنكم توافقون على الالتزام بهذه الشروط.",
  [tokens.terms.page.acceptance.title]: "قبول الشروط",
  [tokens.terms.page.acceptance.content]:
    "من خلال الوصول إلى هذا الموقع واستخدامه، فإنكم تقبلون وتوافقون على الالتزام بشروط وأحكام هذه الاتفاقية. إذا كنتم لا توافقون على الالتزام بما ورد أعلاه، يرجى عدم استخدام هذه الخدمة.",
  [tokens.terms.page.services.title]: "استخدام الخدمات",
  [tokens.terms.page.services.content]:
    "خدماتنا مخصصة لمقدمي الرعاية الصحية المهنيين والأفراد الذين يسعون للحصول على معلومات حول علاجات التجميل. توافقون على استخدام خدماتنا فقط للأغراض القانونية ووفقاً لهذه الشروط والأحكام.",
  [tokens.terms.page.privacy.title]: "الخصوصية وحماية البيانات",
  [tokens.terms.page.privacy.content]:
    "نحن ملتزمون بحماية خصوصيتكم. أي معلومات شخصية يتم جمعها من خلال موقعنا الإلكتروني سيتم التعامل معها وفقاً لسياسة الخصوصية الخاصة بنا وقوانين حماية البيانات المعمول بها.",
  [tokens.terms.page.liability.title]: "تحديد المسؤولية",
  [tokens.terms.page.liability.content]:
    "لن تكون داينامكس ميديكا مسؤولة عن أي أضرار مباشرة أو غير مباشرة أو عرضية أو خاصة أو تبعية ناتجة عن استخدام أو عدم القدرة على استخدام خدماتنا، حتى لو تم إخطارنا بإمكانية حدوث مثل هذه الأضرار.",
  [tokens.terms.page.modifications.title]: "تعديل الشروط",
  [tokens.terms.page.modifications.content]:
    "نحتفظ بالحق في تعديل هذه الشروط والأحكام في أي وقت. ستصبح التغييرات سارية المفعول فور نشرها على موقعنا الإلكتروني. استمراركم في استخدام خدماتنا يشكل قبولاً للشروط المعدلة.",
  [tokens.terms.page.contact.title]: "معلومات الاتصال",
  [tokens.terms.page.contact.content]:
    "إذا كان لديكم أي أسئلة حول هذه الشروط والأحكام، يرجى التواصل معنا على Info@dynainv.com أو من خلال نموذج الاتصال الخاص بنا.",


  // drcyj

  [tokens.brands.drcyj.title]: "د. ﺳﻲ واي ﺟﺎي",
  [tokens.brands.drcyj.subtitle]: "اكتشف د. سي واي جاي",
  [tokens.brands.drcyj.description]: "الجيل الجديد من الفيلرز الديناميكية والعملية.حل متطور لإعادة حيوية الشعر فيلر للشعر مصمم سريريًا لدعم صحة فروة الرأس، وتنشيط بصيلات الشعر، والمساعدة في تقليل ترقق الشعر للحصول على شعر أقوى وأكثر صحة بشكل ملحوظ.",
  // "The New Generation of Dynamic and Practical Fillers Advanced Hair Revitalizing Solution. A clinically designed hair filler formulated to support scalp health, activate hair follicles, and help reduce hair thinning for visibly stronger, healthier-looking hair.",
  [tokens.brands.drcyj.description2]:"يجمع علاج فيلر الشعر المتخصص لدينا بين حمض الهيالورونيك ومركّب قوي من الببتيدات لدعم صحة فروة الرأس وتحفيز نشاط بصيلات الشعر. ويتم حقنه مباشرة في فروة الرأس، حيث يساعد د. سي واي جاي على تقليل تساقط الشعر، وتحسين كثافة الشعر، وتعزيز نمو شعر أكثر صحة.",

  [tokens.brands.drcyj.whatIs]: "ما هو د. ﺳﻲ واي ﺟﺎي؟",
  [tokens.brands.drcyj.whatIsDescription]: "يُعدّ مُكثّف الشعر من دكتور سي واي جيه علاجًا مبتكرًا لفروة الرأس، مُصمّمًا لتجديد بصيلات الشعر الضعيفة أو الخاملة، ودعم نمو شعر صحي. تساعد تركيبته المتطورة من الببتيدات على تحسين الدورة الدموية الدقيقة في فروة الرأس، والحدّ من تساقط الشعر المفرط، وتعزيز حيوية الشعر بشكل عام. طُوّر هذا المنتج للأفراد الذين يبحثون عن تحسينات آمنة وفعّالة وملحوظة مع فترة نقاهة قصيرة.",
  // "DR.CYJ Hair Filler is an innovative scalp treatment designed to rejuvenate weak or dormant hair follicles and support healthier hair growth. Its advanced peptide formula helps improve microcirculation in the scalp, reduce excessive hair fall, and enhance the overall vitality of the hair. Developed for individuals seeking safe, effective, and noticeable improvements with minimal downtime.",


  // drcyj (Shape 2)
  [tokens.brands.drcyj.product.title]: "فيلر شعر د. سي واي جي",
  [tokens.brands.drcyj.product.subtitle]:"علاج لتجديد فروة الرأس لشعر أقوى وأكثر صحة",

  // Section titles
  [tokens.brands.drcyj.product.featuresTitle]: "مميزات المنتج",
  [tokens.brands.drcyj.product.treatmentTitle]: "العلاج",
  [tokens.brands.drcyj.product.keyBenefitsTitle]: "الفوائد الرئيسية",
  [tokens.brands.drcyj.product.functionTitle]: "الوظيفة",

  // Product Features list
  [tokens.brands.drcyj.product.features[0]]: "تركيبة تحتوي على مركبات ببتيدية متقدمة",
  [tokens.brands.drcyj.product.features[1]]: "يستهدف البصيلات الضعيفة أو المجهدة أو التي تعاني من الترقق",
  [tokens.brands.drcyj.product.features[2]]:
    "يدعم تحسين الدورة الدموية الدقيقة في فروة الرأس",
  [tokens.brands.drcyj.product.features[3]]: "يساعد على استعادة كثافة الشعر وحيويته",





  
  // // Treatment list
  [tokens.brands.drcyj.product.treatmentItems[0]]: "يُطبّق مباشرة على فروة الرأس",
  [tokens.brands.drcyj.product.treatmentItems[1]]: "يُوصى به كخطة علاج تعتمد على الجلسات",
  [tokens.brands.drcyj.product.treatmentItems[2]]: "فترة تعافٍ قصيرة مع عملية تطبيق مريحة",




  // // Key Benefits list
  [tokens.brands.drcyj.product.keyBenefitsItems[0]]: "يدعم شعراً أكثر صحة وقوة",
  [tokens.brands.drcyj.product.keyBenefitsItems[1]]: "يساعد في تقليل ترقق الشعر والتساقط المفرط",
  [tokens.brands.drcyj.product.keyBenefitsItems[2]]: "يعزز استعادة كثافة الشعر",
  [tokens.brands.drcyj.product.keyBenefitsItems[3]]:
    "مناسب للرجال والنساء الذين يعانون من بداية تساقط الشعر المبكر",



  // // Function list
  [tokens.brands.drcyj.product.functionItems[0]]: "يحفّز تدفق الدم في فروة الرأس",
  [tokens.brands.drcyj.product.functionItems[1]]: "ينشّط بصيلات الشعر الخاملة",
  [tokens.brands.drcyj.product.functionItems[2]]: "يساعد على تقليل تساقط الشعر",
  [tokens.brands.drcyj.product.functionItems[3]]: "يعزز إعادة نمو الشعر بشكل طبيعي",



  [tokens.brands.drcyj.productoverviewTitle]:
    "كيف يعمل؟",
  [tokens.brands.drcyj.productoverviewDesc]:"تستقر تركيبة د. سي واي جي خفيفة الوزن داخل أنسجة فروة الرأس، مما يسمح للببتيدات بالانتشار تدريجيًا عبر منطقة العلاج. يساعد هذا البطيء على توفير بيئة صحية حول بصيلات الشعر ويساهم في الحفاظ على حالة مثالية لفروة الرأس مع مرور الوقت.",


    // dimono

    [tokens.brands.dimono.title]: "سي جي ديمونو بي تي إكس",
    [tokens.brands.dimono.subtitle]: "اكتشف سي جي ديمونو بي تي إكس",
    [tokens.brands.dimono.description]:"فيلر جلدي متطور مصمم لتنعيم خطوط التعبير، واستعادة حجم الوجه، وتعزيز جودة البشرة بشكل عام.",
    // "An advanced dermal filler designed to smooth expression lines, restore facial volume, and enhance overall skin quality.",
    //  "The New Generation of Dynamic and Practical Fillers in Aesthetic Skincare. A dynamic dermal filler designed to smooth expression lines, enhance skin quality, and restore a refreshed appearance.",
    [tokens.brands.dimono.description2]:"تعمل تركيبتنا المتطورة القابلة للحقن على تحسين جودة البشرة بشكل عام من خلال استهداف الخطوط الدقيقة، وعدم توحد لون البشرة، وعلامات الشيخوخة المبكرة. صُممت تركيبة ديمونو لدعم تحفيز إنتاج الكولاجين وتجديد البشرة على المدى الطويل، مما يوفر مظهرًا طبيعيًا ونضارة مع نتائج متوازنة ومتدرجة.",
    // "تعمل تركيبتنا المتطورة القابلة للحقن على تحسين جودة البشرة بشكل عام من خلال استهداف الخطوط الدقيقة، وعدم توحد لون البشرة، وعلامات الشيخوخة المبكرة. صُممت تركيبة ديمونو لدعم تحفيز إنتاج الكولاجين وتجديد البشرة على المدى الطويل، مما يوفر مظهرًا طبيعيًا ونضارة مع نتائج متوازنة ومتدرجة.",
  
    [tokens.brands.dimono.whatIs]: "ما هو سي جي ديمونو بي تي إكس؟",
    [tokens.brands.dimono.whatIsDescription]:
      "سي جي ديمونو بي تي إكس هو حشو جلدي مبتكر صُمم لعلاج الخطوط الدقيقة والتجاعيد ومناطق فقدان الحجم الناتجة عن حركة الوجه والتقدم في العمر. تجمع تركيبته الفريدة بين حمض الهيالورونيك والببتيدات المتخصصة لدعم نعومة الملمس وتحسين الترطيب واستعادة نضارة البشرة. وقد طُوِّر للمرضى الذين يبحثون عن نتائج آمنة وفعالة وطبيعية مع فترة تعافٍ قصيرة.",
    [tokens.brands.dimono.box2Title]:
      "عملية تحويلية للحفاظ على سلاسل حمض الهيالورونيك الجزيئية الطويلة",
    
    // DIMONO (Shape 2)
    [tokens.brands.dimono.product.title]: "حشو جلدي ديمونو بي تي إكس",
    
    [tokens.brands.dimono.product.subtitle]:
      "تنعيم خطوط التعبير وتحسين ملمس البشرة",
    
    // Section titles
    [tokens.brands.dimono.product.featuresTitle]: "مميزات المنتج",
    [tokens.brands.dimono.product.treatmentTitle]: "العلاج",
    [tokens.brands.dimono.product.keyBenefitsTitle]: "الفوائد الرئيسية",
    [tokens.brands.dimono.product.functionTitle]: "الوظيفة",
    
    // Product Features list
    [tokens.brands.dimono.product.features[0]]: "متوفر بحجم 1 مل + 2 مل",
    [tokens.brands.dimono.product.features[1]]: "تقنية قائمة على الببتيدات حاصلة على براءة اختراع",
    [tokens.brands.dimono.product.features[2]]:
      "علاج مريح مع تحسن فوري في مظهر البشرة",
    [tokens.brands.dimono.product.features[3]]: "نتائج فورية تدوم حتى شهرين",
    
    // Treatment list
    [tokens.brands.dimono.product.treatmentItems[0]]: "حقن جلدي خطي داخل الأدمة",
    [tokens.brands.dimono.product.treatmentItems[1]]: "جلسة واحدة كل شهرين",
    [tokens.brands.dimono.product.treatmentItems[2]]: "يوصى بـ 4-5 جلسات سنويًا",
    
    // Key Benefits list
    [tokens.brands.dimono.product.keyBenefitsItems[0]]: "يخفف الخطوط الدقيقة والتجاعيد الديناميكية",
    [tokens.brands.dimono.product.keyBenefitsItems[1]]: "يحسن ملمس البشرة ومرونتها",
    [tokens.brands.dimono.product.keyBenefitsItems[2]]: "يعزز ترطيب البشرة لمظهر أكثر صحة",
    [tokens.brands.dimono.product.keyBenefitsItems[3]]:
      "يمنح نتائج جمالية طبيعية ومتوازنة",
    [tokens.brands.dimono.product.keyBenefitsItems[4]]: "مناسب لمناطق متعددة من الوجه",
    
    // Function list
    [tokens.brands.dimono.product.functionItems[0]]: "يساعد على تقليل توتر العضلات",
    [tokens.brands.dimono.product.functionItems[1]]: "يخفف الخطوط الدقيقة والتجاعيد",
    [tokens.brands.dimono.product.functionItems[2]]:
      "يمنح البشرة إشراقًا وحيوية أكبر",
    
    [tokens.brands.dimono.productoverviewTitle]: "كيف يعمل؟",
    [tokens.brands.dimono.productoverviewDesc]:
      "بمجرد تطبيقه، يندمج Dimono PTx مع أنسجة الأدمة بتركيبة مرنة تتحرك بانسجام مع تعابير الوجه. يساهم هذا الاندماج السلس في تحسين ملمس البشرة والحفاظ على مظهر طبيعي دون إحساس بالصلابة أو الثقل.",
    
    [tokens.brands.dimono.applicationAreas[0]]: "التجاعيد العمودية",
    [tokens.brands.dimono.applicationAreas[1]]: "تجاعيد العين الدقيقة",
    [tokens.brands.dimono.applicationAreas[2]]: "الخطوط الدقيقة تحت العين",
    [tokens.brands.dimono.applicationAreas[3]]: "طيات الأنف الشفوية",
    [tokens.brands.dimono.applicationAreas[4]]: "التجاعيد حول الفم",
    [tokens.brands.dimono.applicationAreas[5]]: "خطوط الجبهة",
    [tokens.brands.dimono.applicationAreas[6]]: "خطوط الشفاه (الباركود)",
    [tokens.brands.dimono.applicationAreas[7]]: "تجاعيد الرقبة",
    [tokens.brands.dimono.applicationAreas[8]]: "الذقن وأسفل الوجه",
    [tokens.brands.dimono.applicationAreas[9]]: "تجديد شباب اليدين",
    

    [tokens.brands.maili.title]: "مايلي",
[tokens.brands.maili.subtitle]: "استكشف مايلي",
[tokens.brands.maili.description]: "انعكاس حقيقي للرقي الجمالي",

[tokens.brands.maili.description2]:"يساعد فيلر حمض الهيالورونيك المتطور على تعزيز الحجم وتنعيم التجاعيد وتحديد الملامح بنتائج ناعمة وطبيعية تتحرك بانسجام مع تعابير الوجه.",

[tokens.brands.maili.whatIs]: "نقدم لكم مايلي",
[tokens.brands.maili.whatIsDescription]:
  "الاهتمام بالتفاصيل والرقي هما جوهر ما نقوم به. سنساعدك على إشعاع الثقة التي تأتي من معرفة أنك تبدين وتشعرين بأفضل حال. تتوفر علاجات MaiLi HA للفيلر الجلدي حصريًا في مراكز التميز الخاصة بنا، حيث ستتلقين العلاج على يد مختصين مؤهلين تأهيلًا عاليًا.",

[tokens.brands.maili.box2Title]:
  "عملية تحوّل للحفاظ على سلاسل HA طويلة الجزيئات",

[tokens.brands.maili.box2p1]:
  "تقنية OxiFree™ تخلق جلًا فريدًا بمرونة تشبه الزنبرك، ويشرح Smart Spring Science هذه الخصائص، جل من حمض الهيالورونيك يستجيب بشكل استثنائي للضغط، بينما يعمل بمرونة مع الحركة الطبيعية وتعبيرات الوجه الديناميكية.",

[tokens.brands.maili.productoverviewTitle]:
  "اختراق في جمال حمض الهيالورونيك (HA)",
[tokens.brands.maili.productoverviewDesc]:
  "كل علاج من علاجات حقن حمض الهيالورونيك من مايلي صُمم خصيصًا لك. سواء كنت ترغبين في تنعيم التجاعيد والخطوط الدقيقة، أو إضافة حجم وتحديد، أو الحصول على بشرة رائعة، فلدينا العلاج المناسب لك. اختاري مايلي للحصول على أفضل علاج تجميلي يمنحك إشراقة وثقة بالنفس. قد تختلف النتائج من مريض لآخر.",

[tokens.brands.maili.articles.title]: "مايلي",
[tokens.brands.maili.articles.subtitle]: "أحدث المقالات",

[tokens.brands.maili.articles.items[0].title]: "لماذا تختار MaiLi",
[tokens.brands.maili.articles.items[0].description]:
  "اكتشف مجموعة MaiLi المكونة من أربعة أنواع متقدمة من فيلر حمض الهيالورونيك المصممة لتمكين الأطباء المتخصصين من تحقيق رؤيتك الجمالية بدقة فاخرة.",

[tokens.brands.maili.articles.items[1].title]: "النتائج",
[tokens.brands.maili.articles.items[1].description]:
  "اختبر مجموعة MaiLi المكونة من أربعة أنواع متقدمة من فيلر حمض الهيالورونيك المصممة لتمكين الأطباء المتخصصين من تحقيق رؤيتك الجمالية بدقة فاخرة.",

[tokens.brands.maili.articles.items[2].title]: "إجابات على أسئلتك",
[tokens.brands.maili.articles.items[2].description]:
  "من المهم جدًا تدليك منطقة العلاج لمدة 10 دقائق مرتين يوميًا لمدة أسبوعين بعد كل جلسة علاج.",

  [tokens.brands.lanluma.title]: "لانلوما",
[tokens.brands.lanluma.subtitle]: "اكتشف لانلوما",
[tokens.brands.lanluma.description]: "تعزيز الجمال والثقة",

[tokens.brands.lanluma.description2]:
  "يعمل علاجنا القابل للحقن المحفز للكولاجين بعمق داخل الجلد لاستعادة الحجم وإعادة تشكيله تدريجيًا في الوجه والجسم. يحفز الإنتاج الطبيعي للكولاجين للحصول على تحديد طويل الأمد بمظهر طبيعي وثقة أكبر.",

[tokens.brands.lanluma.whatIs]: "تعزيز الجمال والثقة",
[tokens.brands.lanluma.whatIsDescription]:
  "لانلوما هو فيلر قابل للحقن محفز للكولاجين للوجه والجسم، يعمل على تحديد الملامح وإعادة تشكيلها وتحفيز إنتاج الكولاجين الطبيعي، مما يمنح المرضى ثقة متجددة بمظهرهم.",

[tokens.brands.lanluma.box2Title]:
  "تمنح لانلوما نتائج طويلة الأمد بمظهر طبيعي",

[tokens.brands.lanluma.box2p1]:
  "لا تعمل لانلوما بالطريقة نفسها التي تعمل بها حقن حمض الهيالورونيك (HA)، لأنه لا يملأ المناطق ببساطة باستخدام الجل. بدلاً من ذلك، تعمل جزيئات PLLA بذكاء في عمق الجلد لتحفيز استجابة الجسم الطبيعية في إنتاج الكولاجين، مما يمنح نتائج تدوم أكثر من عامين. (J Am Acad Dermatol 2010;62:448-62)",

[tokens.brands.lanluma.box2p2]:
  "إيلانسي مخصص لتصحيح فقدان حجم الوجه بشكل طويل الأمد وللزراعة تحت الجلد في الوجه.",

[tokens.brands.lanluma.productoverviewTitle]:
  "الشكل هو أسلوب",
[tokens.brands.lanluma.productoverviewDesc]:
  "لانلوما هو احتفاء بالشكل والبنية واكتشاف الثقة من خلالهما. يساعد لانلوما على تقليل مظهر التجاعيد وإعادة تشكيل وتحديد ملامح الوجه والجسم.",

[tokens.brands.lanluma.box3p1]:
  "نقدّم تدريبًا مكثفًا لأطبائنا لإعداد مختصين مدربين تدريبًا عاليًا على الحقن، ونعمل مع أفضل الأطباء في هذا المجال. المكوّن الرئيسي القابل للحقن في لانلوما، وهو حمض البولي لاكتيك (PLLA)، يحفز الإنتاج الطبيعي للكولاجين الخاص بالجسم نفسه، مما يمنح تأثيرات تدوم أكثر من عامين. (المجلة الأمريكية لأمراض الجلدية 2010؛ 62:448-62).",

[tokens.brands.lanluma.articles.title]: "لانلوما",
[tokens.brands.lanluma.articles.subtitle]: "أحدث المقالات",

[tokens.brands.lanluma.articles.items[0].title]: "دليل العناية بعد العلاج",
[tokens.brands.lanluma.articles.items[0].description]:
  "بعد العلاج، سيشرح لكِ طبيبكِ المختص كل ما يلزم ويوفر لكِ دليلًا سهلًا للعناية بعد العلاج يمكنكِ اتباعه.",

[tokens.brands.lanluma.articles.items[1].title]: "شد الأرداف بدون جراحة",
[tokens.brands.lanluma.articles.items[1].description]:
  "هذا الفيلر المبتكر يعيد تشكيل الجسم ويحّفز إنتاج الكولاجين الطبيعي بما يعزز حجمًا طبيعيًا يبرز منحنيات الجسم بشكل متناسق وجذاب.",

[tokens.brands.lanluma.articles.items[2].title]: "قبل وبعد",
[tokens.brands.lanluma.articles.items[2].description]:
  "من المهم جدًا تدليك منطقة العلاج لمدة 10 دقائق مرتين يوميًا لمدة أسبوعين بعد كل جلسة علاج.",




  [tokens.brands.ellanse.title]: "إيلانسي",
[tokens.brands.ellanse.subtitle]: "اكتشف إيلانسي",
[tokens.brands.ellanse.description]: "سر تجديد شباب الوجه",

[tokens.brands.ellanse.description2]: "تجديد ثنائي التأثير يمنح حجمًا فوريًا مع تحفيز الكولاجين الطبيعي لنتائج متجددة وطويلة الأمد بمظهر أكثر نعومة وتوازنًا.",
  // "يوفر الفيلر المحفز للكولاجين ذو التأثير المزدوج حجمًا فوريًا مع تنشيط الإنتاج الطبيعي للكولاجين في الجسم. يساعد على استعادة بنية الوجه، وتنعيم الخطوط، ومنح تجديد راقٍ وطويل الأمد من الداخل.",

[tokens.brands.ellanse.whatIs]: "حجم فوري، وفوائد طويلة الأمد",
[tokens.brands.ellanse.whatIsDescription]:
  "عندما يتعلق الأمر بتحسين مظهرك، فأنت لا ترغبين في حل مؤقت. بل ترغبين في طريقة آمنة* لتجديد بشرتك، تعزز جمالك وتمنحك نتائج تدوم. وهنا يأتي دورنا... *البيانات محفوظة في الملف",

[tokens.brands.ellanse.box2Title]: "إعادة بناء جمالك الطبيعي",

[tokens.brands.ellanse.box2p1]:
  "يتجاوز إيلانسي مجرد تصحيح الخطوط والتجاعيد من خلال معالجة الأسباب الجذرية لشيخوخة الوجه. فهو يمنح نتائج فورية، وفي الوقت نفسه يحفز الإنتاج الطبيعي للكولاجين في الجسم لاستعادة الحجم وتجديد الوجه من الداخل. ويُستخدم إيلانسي لتصحيح فقدان حجم الوجه بشكل طويل الأمد من خلال الزرع تحت الجلد في الوجه.",

[tokens.brands.ellanse.box2p2]:
  "يُستخدم إيلانسي للتصحيح طويل الأمد لفقدان حجم الوجه وللزراعة تحت الجلد في الوجه.",

[tokens.brands.ellanse.productoverviewTitle]:
  "سر تجديد شباب الوجه",
[tokens.brands.ellanse.productoverviewDesc]:
  "إيلانسي هو الفيلر الجلدي الوحيد الذي يحقق حجمًا فوريًا ونتائج طويلة الأمد عبر تحفيز الكولاجين الذاتي، مما يمنح بشرة أكثر إشراقًا مع تحسن في الكثافة والشد والمرونة.",

[tokens.brands.ellanse.box3p1]:
  "نوفّر تدريبًا مكثفًا لإعداد مستخدمين خبراء، ونعمل فقط مع أفضل الأطباء في هذا المجال. يقدّم إيلانسي مجموعة من المنتجات لتلبية احتياجات متنوعة، بدءًا من تصحيح التجاعيد وصولًا إلى منح الشكل والحجم. وتمنح خصائصه مزدوجة التأثير المرضى نتائج فورية وطويلة الأمد* مع تحفيز طبيعي لكولاجين النوع الأول. *البيانات محفوظة في الملف.",

[tokens.brands.ellanse.articles.title]: "إيلانسي",
[tokens.brands.ellanse.articles.subtitle]: "أحدث المقالات",

[tokens.brands.ellanse.articles.items[0].title]: "كيف تبدأ علامات التقدم في السن بالظهور",
[tokens.brands.ellanse.articles.items[0].description]:
  "لا تعني علامات شيخوخة الوجه بالضرورة أنكِ أصبحتِ كبيرة في السن. فهي تبدأ عادةً بالظهور في العشرينات من العمر عندما تبدأ مستويات الكولاجين والإيلاستين، وهما البروتينان اللذان يمنحان البشرة بنيتها، في الانخفاض.",

[tokens.brands.ellanse.articles.items[1].title]: "شاهد نتائج حقيقية للمرضى",
[tokens.brands.ellanse.articles.items[1].description]:
  "القوة تكمن في النتائج، شاهديها بنفسك.",

[tokens.brands.ellanse.articles.items[2].title]: "هل أنتِ مستعدة للتحدث إلى طبيب؟",
[tokens.brands.ellanse.articles.items[2].description]:
  

"استخدمي أداة البحث عن الأطباء لدينا أو تواصلي معنا لمساعدتك في العثور على طبيب إيلانسي بالقرب منك.",
  [tokens.brands.juvelook.buttonText]: "اكتشف جوفيلوك",
  [tokens.brands.lenisna.buttonText]: "اكتشف لينسينا",
  [tokens.brands.ksurgery.buttonText]: "اكتشف كيه سرجري",
  [tokens.brands.maili.buttonText]: "اكتشف مايلي",
  [tokens.brands.drcyj.buttonText]: "اكتشف د. ﺳﻲ واي ﺟﺎي",
  [tokens.brands.lanluma.buttonText]: "اكتشف لانلوما",
  [tokens.brands.ellanse.buttonText]: "اكتشف إلانسي",
  [tokens.brands.dimono.buttonText]: "اكتشف سي جي ديمونو بي تي إكس",
  [tokens.brands.renee.buttonText]: "اكتشف رينيه",
  };
